/*
 * 再入荷リクエストボタン（snippets/lm-restock-request.liquid と対）
 * - バリエーション切り替え（theme:variant:change）で在庫切れならカートボタンを隠して差し替え
 * - ログイン中はボタン押下で App Proxy /apps/localmotion/restock に登録
 * - クイックビューなど後から差し込まれた商品フォームにも対応（MutationObserver）
 */
(function () {
  if (window.__lmRestockLoaded) return;
  window.__lmRestockLoaded = true;

  var ENDPOINT = '/apps/localmotion/restock';
  var requestedCache = {}; // variantId -> true（ログイン中の顧客がリクエスト済み）

  function $(root, sel) { return root.querySelector(sel); }
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }

  function init(root) {
    if (root.__lmInit) return;
    root.__lmInit = true;

    var scope = root.closest('[data-product-form-outer]') || root.closest('form') || root.parentElement;
    var cartButtons = scope ? scope.querySelector('.product__submit__buttons') : null;
    var loggedIn = root.getAttribute('data-logged-in') === 'true';
    var current = root.getAttribute('data-variant-id');
    var available = root.getAttribute('data-available') === 'true';

    var btn = $(root, '[data-lm-restock-btn]');
    var note = $(root, '[data-lm-restock-note]');
    var done = $(root, '[data-lm-restock-done]');
    var err = $(root, '[data-lm-restock-error]');
    var cancel = $(root, '[data-lm-restock-cancel]');
    var login = $(root, '[data-lm-restock-login]');

    function renderRequested() {
      if (!loggedIn) return;
      var req = !!requestedCache[current];
      if (btn) {
        btn.disabled = req;
        btn.textContent = req ? '再入荷リクエスト済み' : '再入荷リクエスト';
      }
      show(note, !req);
      show(done, req);
    }

    function apply() {
      show(root, !available);
      if (cartButtons) cartButtons.style.display = available ? '' : 'none';
      show(err, false);
      if (login) {
        var ret = encodeURIComponent((root.getAttribute('data-product-url') || location.pathname) + '?variant=' + current);
        login.href = root.getAttribute('data-login-mode') === 'new'
          ? '/customer_authentication/login?return_to=' + ret + '&locale=' + (document.documentElement.lang || 'ja')
          : '/account/login?return_url=' + ret;
      }
      renderRequested();
    }

    function showError(msg) {
      if (!err) return;
      err.textContent = msg;
      show(err, true);
    }

    function post(intent) {
      var body = new URLSearchParams();
      body.set('intent', intent);
      body.set('variant_id', current);
      body.set('email', root.getAttribute('data-email') || '');
      body.set('name', root.getAttribute('data-name') || '');
      return fetch(ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString()
      }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'http_' + r.status }; }); });
    }

    var MESSAGES = {
      login_required: 'ログインの有効期限が切れました。ページを再読み込みしてログインしてください。',
      not_eligible: 'この商品は現在、再入荷リクエストの対象外です。',
      no_email: 'メールアドレスが確認できませんでした。アカウント情報をご確認ください。'
    };

    if (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        show(err, false);
        post('request').then(function (res) {
          if (res && res.ok) {
            requestedCache[current] = true;
          } else {
            showError(MESSAGES[res && res.error] || '送信できませんでした。時間をおいて再度お試しください。');
          }
          btn.disabled = false;
          renderRequested();
        }).catch(function () {
          btn.disabled = false;
          showError('通信エラーが発生しました。時間をおいて再度お試しください。');
        });
      });
    }

    if (cancel) {
      cancel.addEventListener('click', function () {
        post('cancel').then(function (res) {
          if (res && res.ok) delete requestedCache[current];
          renderRequested();
        });
      });
    }

    // バリエーション切り替え（Pipeline テーマはセクションから bubbles で発火）
    document.addEventListener('theme:variant:change', function (e) {
      if (!e.target || !e.target.contains || !e.target.contains(root)) return;
      var v = e.detail && e.detail.variant;
      if (v) {
        current = String(v.id);
        available = !!v.available;
      } else {
        available = true; // 存在しない組み合わせ → テーマ標準の表示に任せる
      }
      apply();
    });

    // ログイン中：この商品のリクエスト状況を取得
    if (loggedIn) {
      var ids = root.getAttribute('data-variants') || current;
      fetch(ENDPOINT + '?variant_ids=' + encodeURIComponent(ids), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          (res && res.requested || []).forEach(function (id) { requestedCache[String(id)] = true; });
          renderRequested();
        })
        .catch(function () {});
    }

    apply();
  }

  function scan(node) {
    var list = (node || document).querySelectorAll ? (node || document).querySelectorAll('[data-lm-restock]') : [];
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute && n.hasAttribute('data-lm-restock')) init(n);
          else if (n.querySelector && n.querySelector('[data-lm-restock]')) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
